import { getCommercialOutboundConfirm, getResearchOutboundConfirm, } from "../api/generated/wrappers/outbound";
import { getCommercialOutboundProductAll, getResearchOutboundProductAll, } from "../api/generated/wrappers/outbound";
import { getCommercialOutboundProducts, getResearchOutboundProducts, } from "../api/generated/wrappers/outbound";
import { createQueryKeys } from "./create-query-keys";
const outboundQueryKeys = createQueryKeys("outbound", {
    confirm: (isCommercial, params) => ({
        queryKey: ["confirm", isCommercial, params],
        queryFn: async () => isCommercial
            ? await getCommercialOutboundConfirm(params)
            : await getResearchOutboundConfirm(params),
    }),
    productAll: (isCommercial, params) => ({
        queryKey: ["productAll", isCommercial, params],
        queryFn: async () => isCommercial
            ? await getCommercialOutboundProductAll(params)
            : await getResearchOutboundProductAll(params),
    }),
    products: (isCommercial, outboundId) => ({
        queryKey: ["products", isCommercial, outboundId],
        queryFn: async () => isCommercial
            ? await getCommercialOutboundProducts(outboundId)
            : await getResearchOutboundProducts(outboundId),
    }),
});
export default outboundQueryKeys;
